export const environment = {
  production: false,
  msalConfig: {
    auth: {
      clientId: '1aaf7b80-c4a6-42bf-ae1f-b23866db5b8f',
      authority: 'https://login.microsoftonline.com/6c6faf78-2920-4cab-8820-df3254e685bd',
    },
  },
  apiConfig: {
    scopes: ['api://526244ba-d9e6-4a27-9246-e745011a0683/tmaas.mm'],
    uri: 'https://api.tmaas.aae-hub-dev.com',
  },
  webSocketConfig: {
    uri: 'wss://ws.tmaas.aae-hub-dev.com',
  },
};